export const legacyProducts = [
  {
    id: 'credits15_v1',
    name: '15 Credits',
    description: 'Base price with no discount',
    unitSize: 15,
    unitPrice: 60,
    recurring: {
      usageType: 'reserved',
      interval: 1,
    },
  },
  {
    id: 'credits50_v1',
    name: '50 Credits',
    description: '12.5% volume discount',
    unitSize: 50,
    unitPrice: 175,
    recurring: {
      usageType: 'reserved',
      interval: 1,
    },
  },
  {
    id: 'credits300_v1',
    name: '300 Credits',
    description: '37.5% volume discount',
    unitSize: 300,
    unitPrice: 750,
    recurring: {
      usageType: 'reserved',
      interval: 1,
    },
  },
  {
    id: 'credits15_smallbusiness_v1',
    name: '15 Credits (small business)',
    description: '20% small business discount',
    unitSize: 15,
    unitPrice: 48,
    recurring: {
      usageType: 'reserved',
      interval: 1,
    },
  },
  {
    id: 'credits50_smallbusiness_v1',
    name: '50 Credits (small business)',
    description: '34.5% small business volume discount',
    unitSize: 50,
    unitPrice: 131,
    recurring: {
      usageType: 'reserved',
      interval: 1,
    },
  },
  {
    id: 'credits300_smallbusiness_v1',
    name: '300 Credits (small business)',
    description: '68.75% small business volume discount',
    unitSize: 300,
    unitPrice: 375,
    recurring: {
      usageType: 'reserved',
      interval: 1,
    },
  },
  {
    id: 'credits15_months12_v1',
    name: '15 Credits (12 months)',
    description: '15 credits per month for 12 months with 20% annual discount',
    unitSize: 15,
    unitPrice: 48,
    recurring: {
      usageType: 'reserved',
      interval: 1,
    },
  },
  {
    id: 'credits50_months12_v1',
    name: '50 Credits (12 months)',
    description: '50 credits per month for 12 months with 30% annual volume discount',
    unitSize: 50,
    unitPrice: 140,
    recurring: {
      usageType: 'reserved',
      interval: 1,
    },
  },
  {
    id: 'credits300_months12_v1',
    name: '300 Credits (12 months)',
    description: '300 credits per month for 12 months with 50% annual volume discount',
    unitSize: 300,
    unitPrice: 600,
    recurring: {
      usageType: 'reserved',
      interval: 1,
    },
  },
  {
    id: 'credits15_months12_smallbusiness_v1',
    name: '15 Credits (12 months, small business)',
    description: '15 credits per month for 12 months with 36.7% annual small business discount',
    unitSize: 15,
    unitPrice: 38,
    recurring: {
      usageType: 'reserved',
      interval: 1,
    },
  },
  {
    id: 'credits50_months12_smallbusiness_v1',
    name: '50 Credits (12 months, small business)',
    description:
      '50 credits per month for 12 months with 47.5% annual small business volume discount',
    unitSize: 50,
    unitPrice: 105,
    recurring: {
      usageType: 'reserved',
      interval: 1,
    },
  },
  {
    id: 'credits300_months12_smallbusiness_v1',
    name: '300 Credits (12 months, small business)',
    description:
      '300 credits per month for 12 months with 75% annual small business volume discount',
    unitSize: 300,
    unitPrice: 300,
    recurring: {
      usageType: 'reserved',
      interval: 1,
    },
  },
  {
    id: 'credits15_months12_upfront_v1',
    name: '15 Credits (12 months, paid upfront)',
    description:
      '15 credits per month for 12 months with 20% annual discount and 10% upfront payment discount',
    unitSize: 15,
    unitPrice: 518,
    recurring: {
      usageType: 'reserved',
      interval: 12,
    },
  },
  {
    id: 'credits50_months12_upfront_v1',
    name: '50 Credits (12 months, paid upfront)',
    description:
      '50 credits per month for 12 months with 30% annual volume discount and 10% upfront payment discount',
    unitSize: 50,
    unitPrice: 1512,
    recurring: {
      usageType: 'reserved',
      interval: 12,
    },
  },
  {
    id: 'credits300_months12_upfront_v1',
    name: '300 Credits (12 months, paid upfront)',
    description:
      '300 credits per month for 12 months with 50% annual volume discount and 10% upfront payment discount',
    unitSize: 300,
    unitPrice: 6480,
    recurring: {
      usageType: 'reserved',
      interval: 12,
    },
  },
  {
    id: 'credits15_months12_s_upfront_v1',
    name: '15 Credits (12 months, small business, paid upfront)',
    description:
      '15 credits per month for 12 months with 36.7% annual small business discount and 10% upfront payment discount',
    unitSize: 15,
    unitPrice: 410,
    recurring: {
      usageType: 'reserved',
      interval: 12,
    },
  },
  {
    id: 'credits50_months12_s_upfront_v1',
    name: '50 Credits (12 months, small business, paid upfront)',
    description:
      '50 credits per month for 12 months with 47.5% annual small business volume discount and 10% upfront payment discount',
    unitSize: 50,
    unitPrice: 1134,
    recurring: {
      usageType: 'reserved',
      interval: 12,
    },
  },
  {
    id: 'credits300_months12_s_upfront_v1',
    name: '300 Credits (12 months, small business, paid upfront)',
    description:
      '300 credits per month for 12 months with 75% annual small business volume discount and 10% upfront payment discount',
    unitSize: 300,
    unitPrice: 3240,
    recurring: {
      usageType: 'reserved',
      interval: 12,
    },
  },
  // Custom agreements products
  {
    id: 'credits1_monthly_v1',
    name: 'Reserved Credits (Monthly)',
    description: 'Base pricing for custom agreements',
    unitSize: 1,
    unitPrice: 4,
    recurring: {
      usageType: 'reserved',
      interval: 1,
    },
  },
  {
    id: 'credits1_yearly_v1',
    name: 'Reserved Credits (Annual)',
    description: 'Base pricing for custom agreements',
    unitSize: 1,
    unitPrice: 4,
    recurring: {
      usageType: 'reserved',
      interval: 12,
    },
  },
  {
    id: 'custom_v1',
    name: 'Custom Product',
    description: 'Custom Product',
  },
]
